<template>
  <div v-resize="onResize">
    <v-layout row wrap px-6 pt-0>
      <v-flex xs12>
        <h1 class="py-md-6">{{ $t("viewCalculations.title") }}</h1>
        <v-card class="mb-2 pa-1 elevation-0 d-none" :loading="calculationIsLoading" >
          <v-row class="pa-2 ma-0">
            <v-flex ma-0 pa-0>
              <v-text-field
                outlined
                :placeholder="$t('viewCalculations.search_placeholder')"
                append-icon="fa-times"
                hide-details
                @click:append="search = ''"
                v-model="search"

              ></v-text-field>
            </v-flex>
          </v-row>
        </v-card>
        <!--        таблица калькуляций     -->
        <v-data-table
          :height="tableHeight"
          ref="calculationsTable"
          :headers="calculationsTableHeader"
          :items="filteredCalculations"
          class="mb-3"
          elevation="0"
          :loading="calculationIsLoading"
          :expanded.sync="expanded"
          single-expand
          @click:row="selectCalculation"
          :footer-props="{
            'items-per-page-text': $t('tables.items_per_page'),
            'items-per-page-options': [
              10, 50, 100,
              //-1
            ],
          }"
        >
          <template v-slot:footer.page-text="props">
            {{
              $t("tables.x_of_y", [
                `${props.pageStart}-${props.pageStop}`,
                props.itemsLength,
              ])
            }}
          </template>
          <template v-slot:[lastHeaderElement]="props">
            {{ props.header.text }}
            <table-config-btn
              :table="tableName"
              :default-columns="defaultCalculationsTableHeader"
            />
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="6" class="pa-0 ma-0">
              <calculation-form v-if="calculation.id"></calculation-form>
            </td>
          </template>
          <template v-slot:item.id="props">
            <span @click="selectCalculation(props.item)">
              {{ props.item.id }}
            </span>
          </template>
          <template v-slot:item.name="props">
            {{ props.item.name }}
          </template>
          <template v-slot:item.customer.last_name="props">
            <span v-if="props.item.customer">
              {{ props.item.customer.last_name }}
              {{ props.item.customer.first_name }}
              {{ props.item.customer.patronymic }}
              {{
                props.item.customer.is_company == 1
                    ? "[" + props.item.customer.legal_name + "]"
                    : ""
              }}
              </span>
            <span v-else>

            </span>
            <div class="d-flex align-center" v-if="props.item.car">
              <div>
                <img
                    align="center"
                    class="brandLogoMiddle mr-1"
                    v-if="!!brandURL(props.item.car.brand)"
                    :src="brandURL(props.item.car.brand)"
                    :title="props.item.car.brand && props.item.car.brand.toUpperCase()"
                />
                <span v-else>
                    {{ props.item.car && props.item.car.brand.toUpperCase() }}
                  </span>
              </div>
              <div class="py-1">
                  <span class="text-caption pr-2"
                  >{{ props.item.car.brand }} {{ props.item.car.family }}
                    {{ props.item.car.model }}</span
                  >
                <beauty-car-number
                    :number="
                      props.item.car.car_number ? props.item.car.car_number : ''
                    "
                    class="d-inline-block small"
                />
              </div>
            </div>


          </template>
          <template v-slot:item.total_sum="props">
            {{ formatCurrency(props.item.total_sum) }}
          </template>
          <template v-slot:item.car="props">
            <template v-if="props.item.car">
              {{ props.item.car.name }}
              <beauty-car-number
                :number="
                  props.item.car.car_number ? props.item.car.car_number : ''
                "
              />
            </template>
          </template>
          <template v-slot:item.created_at="props">
            {{ props.item.created_at | moment("DD.MM.YYYY") }}
            <br/>
            {{ props.item.created_at | moment("HH:mm") }}
          </template>
          <template v-slot:no-data>
            {{ $t("common.no_data_available") }}
          </template>
          <template v-slot:no-results>
            {{ $t("common.no_data_available") }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import BeautyCarNumber from "../../components/common/BeautyCarNumber";
import CalculationForm from "@/components/calculations/CalculationForm";
import TableConfigBtn from "@/components/common/TableConfigBtn";
import CommonMixin from "@/mixins/common";

export default {
  name: "Calculations",
  components: { TableConfigBtn, CalculationForm, BeautyCarNumber },
  mounted() {
    this.$store.dispatch("tables_config/get").then(() => {
      this.$store.dispatch("cart/getCalculations");
    });
  },
  mixins: [CommonMixin],
  data: () => ({
    tableName: "calculations",
    expanded: [],
    search: "",
    tableHeight: "100",
  }),
  computed: {
    ...mapFields("site", ["lang"]),
    ...mapFields("cart", [
      "calculations",
      "calculation",
      "calculationIsLoading",
    ]),
    calculationType() {
      if (
        this.calculationItemsForShow.parts &&
        this.calculationItemsForShow.repairtimes
      )
        return "summary";
      if (
        this.calculationItemsForShow.parts &&
        !this.calculationItemsForShow.repairtimes
      )
        return "parts";
      if (
        !this.calculationItemsForShow.parts &&
        this.calculationItemsForShow.repairtimes
      )
        return "repairtimes";
    },
    filteredCalculations() {
      return this.calculations.filter((item) => {
        if (this.search === "") return true;
        let checkCustomer = false;
        let checkCar = false;
        if (item.customer) {
          checkCustomer =
            (item.customer.last_name &&
              item.customer.last_name
                .toUpperCase()
                .indexOf(this.search.toUpperCase()) != -1) ||
            (item.customer.patronymic &&
              item.customer.patronymic
                .toUpperCase()
                .indexOf(this.search.toUpperCase()) != -1) ||
            (item.customer.first_name &&
              item.customer.first_name
                .toUpperCase()
                .indexOf(this.search.toUpperCase()) != -1) ||
            item.customer.phone.indexOf(this.search) != -1;
        }
        if (item.car) {
          checkCar =
            (item.car.car_number
              ? item.car.car_number.toUpperCase()
              : ""
            ).indexOf(this.search.toUpperCase()) != -1 ||
            (item.car.name ? item.car.name.toUpperCase() : "").indexOf(
              this.search.toUpperCase()
            ) != -1 ||
            (item.car.vin ? item.car.vin.toUpperCase() : "").indexOf(
              this.search.toUpperCase()
            ) != -1;
        }
        return checkCustomer || checkCar || item.id == this.search;
      });
    },
    lastHeaderElement() {
      return (
        "header." +
        (this.calculationsTableHeader.slice(-1) &&
          this.calculationsTableHeader.slice(-1)[0] &&
          this.calculationsTableHeader.slice(-1)[0].value)
      );
    },
    calculationsTableHeader() {
      let tableHeaderConfig = this.getConfiguredTableHeader(
        this.tableName,
        this.defaultCalculationsTableHeader
      );
      return tableHeaderConfig.filter((item) => item.is_hidden !== true);
    },
    defaultCalculationsTableHeader() {
      return [
        {
          text: this.$t("viewOrders.tableHeader.human_number"),
          value: "id",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.customer"),
          value: "customer.last_name",
          sortable: true,
          align: "left",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.total_sum"),
          value: "total_sum",
          sortable: true,
          align: "end",
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewOrders.tableHeader.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
      ];
    },
  },
  methods: {
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["calculationsTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
    selectCalculation(item) {
      if (this.expanded.includes(item)) {
        this.expanded = [];
        this.$router.push({ name: "calculations" });
      } else {
        this.expanded = [];
        this.expanded.push(item);
        if (item.id > 0) {
          this.selectedOrder = item.id;
          if (this.$route.params.id != item.id) {
            this.$router.push({
              name: "calculations",
              params: { id: item.id },
            });
          }
          this.$store.dispatch("cart/calculationShow", { id: item.id });
        }
      }
    },
  },
  watch: {
    calculationIsLoading() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
    filteredCalculations(to) {
      if (this.$route.params.id && to && to.length) {
        let item = to.find(
          (el) => parseInt(el.id) === parseInt(this.$route.params.id)
        );
        this.selectCalculation(item);
      }
    },
  },
};
</script>
<style lang="css" scoped>
.brandLogoMiddle {
  width: 16px;
}
</style>